import { createTheming } from "@callstack/react-theme-provider";
import { themes } from "./themes";

// Initialize theming utilities with the brand default (Stark).
const { ThemeProvider, withTheme, useTheme } = createTheming(themes.stark);

export { ThemeProvider, withTheme, useTheme };
